// -----------------------------------------------------------
// @ Common Actions
// -----------------------------------------------------------

import { createAction, props } from '@ngrx/store';

// Load all
export const loadAll = createAction(
    '[Common] Load All',
    props<{ entity: string; query?: string | number }>()
);
export const loadAllSuccess = createAction(
    '[Common] Load All Success',
    props<{ data: any[] }>()
);
export const loadAllFailure = createAction(
    '[Common] Load All Failure',
    props<{ error: string }>()
);

// Load One
export const loadOne = createAction(
    '[Common] Load One',
    props<{ entity: string; id: number }>()
);
export const loadOneSuccess = createAction(
    '[Common] Load One Success',
    props<{ data: any }>()
);
export const loadOneFailure = createAction(
    '[Common] Load One Failure',
    props<{ error: string }>()
);

// Create
export const create = createAction(
    '[Common] Create',
    props<{ entity: string; data: string }>()
);
export const createSuccess = createAction(
    '[Common] Create Success',
    props<{ data: any; success: string }>()
);
export const createFailure = createAction(
    '[Common] Create Failure',
    props<{ error: string }>()
);

// Update
export const update = createAction(
    '[Common] Update',
    props<{ entity: string; data: string; id: number }>()
);
export const updateSuccess = createAction(
    '[Common] Update Success',
    props<{ data: any; success: string }>()
);
export const updateFailure = createAction(
    '[Common] Update Failure',
    props<{ error: string }>()
);

// Delete
export const deleteCommon = createAction(
    '[Common] Delete',
    props<{ entity: string; id: number }>()
);
export const deleteSuccess = createAction(
    '[Common] Delete Success',
    props<{ id: number; success: string }>()
);
export const deleteFailure = createAction(
    '[Common] Delete Failure',
    props<{ error: string }>()
);
